'use client';

import React from 'react';
import { Section } from '@/components/client/Section/Section';
import { Container } from '@/components/client/Container/Container';
import { MainSectionLayout } from '@/features/client/MainSectionLayout/MainSectionLayout';
import { MainSection } from '@/features/client/MainSection/MainSection';
import { ContactUsBanner } from '@/features/client/ContactUsBanner/ContactUsBanner';
import { AboutUs } from '@/features/client/AboutUs/AboutUs';
import { AboutUsSection } from '@/features/client/AboutUsSection/AboutUsSection';
import { TotalsSection } from '@/features/client/TotalsSection/TotalsSection';
import { ExpirienseSection } from '@/features/client/ExpirienseSection/ExpirienseSection';

const AboutUsPage = () => {
  return (
    <div>
      {' '}
      <MainSectionLayout variant="primary">
        <MainSection
          label="About Us"
          title="Your Trusted Home Services Expert"
          description=""
        />
      </MainSectionLayout>
      <Section>
        <Container>
          <AboutUsSection withoutHeader={true} />
        </Container>
      </Section>
      <Section variant="darken">
        <Container>
          <TotalsSection />
        </Container>
      </Section>
      <Section>
        <Container>
          <ExpirienseSection />
        </Container>
      </Section>
      <Section>
        <Container>
          <ContactUsBanner />
        </Container>
      </Section>
    </div>
  );
};

export default AboutUsPage;
